import React from 'react';
import parse from 'html-react-parser';

function DgPicture(props) {
  if (props !== null && props !== void 0 && props.cmsElmt && props !== null && props !== void 0 && props.img) {
    var _props$cmsElmt;

    return /*#__PURE__*/React.createElement("picture", {
      className: props.className ? props.className : ""
    }, parse((_props$cmsElmt = props.cmsElmt(props.name, "image", props.img, props === null || props === void 0 ? void 0 : props.config)) === null || _props$cmsElmt === void 0 ? void 0 : _props$cmsElmt.srcset));
  } else {
    return /*#__PURE__*/React.createElement("picture", {
      className: props.className ? props.className : ""
    }, props.children);
  }
}

export { DgPicture as default };
